export default __webpack_public_path__ + "static/media/26t.29d1227d.jpg";